import {
  ArrowDownToLine,
  ArrowLeftRight,
  ChartColumn,
  ChartPie,
  ChevronLeft,
  ChevronRight,
  CirclePlus,
  Flag,
  History,
  Landmark,
  List,
  Receipt,
  Settings,
  Sparkles,
  Tag,
  Wallet,
  Zap,
  type LucideIcon,
} from 'lucide-react';

/**
 * v0.7.5: the icons the module menu and the back header use, from lucide-react like the rest of
 * the app (one import per icon, so only these are bundled). Always decorative: the text beside an
 * icon carries the name.
 */
const ICONS = {
  back: ChevronLeft,
  chevron: ChevronRight,
  cashflow: ChartPie,
  income: ArrowDownToLine,
  accounts: Landmark,
  owed: ArrowLeftRight,
  limits: Wallet,
  add: CirclePlus,
  settings: Settings,
  list: List,
  bars: ChartColumn,
  tag: Tag,
  sparkle: Sparkles,
  receipt: Receipt,
  history: History,
  bolt: Zap,
  flag: Flag,
} satisfies Record<string, LucideIcon>;

export type IconName = keyof typeof ICONS;

export function Icon({
  name,
  size = 20,
  className,
}: {
  name: IconName;
  size?: number;
  className?: string;
}) {
  const Svg = ICONS[name];
  return (
    <Svg size={size} strokeWidth={1.8} aria-hidden="true" focusable="false" className={className} />
  );
}
